(function () {
    'use strict';

    var initialized = false;
    var linkHelper = null;
    var activeDeferred = null;

    // @ngInject
    function PlaidLinkHelperServiceCtor($q, Plaid, AppConfigService, AnalyticsService, UsersManager) {
        this.Plaid = Plaid;
        this.$q = $q;
        this.AppConfigService = AppConfigService;
        this.AnalyticsService = AnalyticsService;

        this.plaid_products = ['auth']; // default
        this.currInstitutionName = 'unknown';
        this.currInstitutionId = 'unknown';
        UsersManager.on('loggingOut', function onLogout() {
            this.reset();
        }.bind(this));
    }

    Services.PlaidLinkHelperService = Class({
        constructor: PlaidLinkHelperServiceCtor,

        lazyInit: function lazyInit(plaid_products) {
            if (!initialized){
                if (plaid_products) {
                    this.plaid_products = plaid_products;
                }

                var cfg = this.AppConfigService.appConfiguration();
                this.Plaid.then(function(plaid) {
                    linkHelper = plaid.create({
                        clientName: 'HoneyBook',
                        env: cfg.plaidEnv,
                        product: this.plaid_products,
                        key: cfg.plaidPublicKey,
                        apiVersion: 'v2',
                        onSuccess: function onSuccess(token) {
                            this.AnalyticsService.trackSuccess(this, 'plaid token created');
                            this._resolvePromise(token);
                        }.bind(this),
                        onExit: function onExit(error) {
                            this.AnalyticsService.track(this, 'exit plaid modal');
                            this._rejectPromise(error);
                        }.bind(this),
                        onEvent: function(eventName, metadata) {
                            this.AnalyticsService.track(this, 'plaid event ' + eventName);
                            if (eventName === 'HANDOFF' && metadata && !!metadata.institution_name) {
                                this.currInstitutionName = metadata.institution_name;
                                this.currInstitutionId = metadata.institution_id;
                            }
                        }.bind(this)
                    });
                }.bind(this));

                initialized = true;
            }
            return this.plaid_products;
        },

        reset: function reset() {
            initialized = false;
            linkHelper = null;
            activeDeferred = null;
        },

        openPlaidDialog: function openPlaidDialog() {
            if (!initialized) {
                throw "PlaidLinkHelperService is not initialized";
            }

            var deferred = this._getDeferred();
            this.Plaid.then(function() {linkHelper.open();}); // this can't be written as just passing the link helper open callback, as plaid complains it get argument (the promise resolved object)
            return deferred.promise;
        },

        _getDeferred: function _getDeferred() {
            if (activeDeferred) {
                activeDeferred.reject();
            }
            activeDeferred = this.$q.defer();
            return activeDeferred;
        },

        _resolvePromise: function _resolvePromise(value) {
            activeDeferred.resolve(value);
            activeDeferred = null;
        },

        _rejectPromise: function _rejectPromise(value) {
            activeDeferred.reject(value);
            activeDeferred = null;
        }

    });

}());
